<template>
  <div :class="ifImage" class="quote">
    <div v-if="image" class="quote__img">
      <img :src="getImage" alt="Alt description for the image">
    </div>
    <div class="quote__wrapper">
      <h3 class="quote__header">
        <TextHeading color="secondary" variant="title">{{ quote }}</TextHeading>
      </h3>
      <span v-if="author" class="quote__author">{{ author }}</span>
      <BaseButton
        v-if="button"
        href="#"
        class="quote__button"
        variant="primary"
        :aria-label="aria"
      >{{ button }}</BaseButton>
    </div>
  </div>
</template>

<script>
import BaseButton from '../elements/BaseButton.vue'
import TextHeading from '../elements/TextHeading.vue'
export default {
  name: 'PageQuotes',
  components: { TextHeading, BaseButton },
  data() {
    return {
      aria: 'Read More from David Potts'
    }
  },
  props: {
    linkHref: {
      type: String,
      default: null
    },
    linkText: {
      type: String,
      default: null
    },
    quote: {
      type: String,
      default: 'Quote text to go here...'
    },
    author: {
      type: String,
      default: ''
    },
    button: {
      type: String,
      default: ''
    },
    image: {
      type: String,
      default: ''
    }
  },
  computed: {
    getImage() {
      return require('@/assets/images/' + this.image)
    },
    ifImage() {
      return `${(this.image && 'quote--image') || ''}`
    }
  }
}
</script>

<style lang="postcss">
.quote {
  @apply my-12 flex flex-wrap;
}
.quote__header {
  @apply border-l-4 px-6 mb-8;
  border-color: rgba(0, 137, 63, 0.2);
}
.quote__img {
  @apply flex justify-center items-center w-full mb-8;
}
.quote__img img {
  @apply w-full max-w-sm;
}
.quote__wrapper {
  @apply w-full;
}
.quote__author {
  @apply block border-white border-l-4 px-6 mb-8 text-sm font-normal;
}
.quote__button {
  @apply ml-6;
}
.quote--image .quote__header {
  @apply border-0;
}
.quote--image .quote__author {
  @apply border-0;
}
.quote--image .quote__wrapper {
  @apply border-l-4;
  border-color: rgba(0, 137, 63, 0.2);
}
@screen md {
  .quote {
    @apply flex-no-wrap;
  }
  .quote__img {
    @apply w-5/12 mb-0 mr-8;
  }
  .quote__img img {
    @apply max-w-full;
  }
  .quote--image .quote__wrapper {
    @apply w-7/12;
  }
  .quote__header {
    @apply mb-12;
  }
  .quote--image .quote__header {
    @apply mb-8;
  }
}
</style>
